import { render, staticRenderFns } from "./VueAudio.vue?vue&type=template&id=e057a24e&scoped=true&"
import script from "./VueAudio.vue?vue&type=script&lang=js&"
export * from "./VueAudio.vue?vue&type=script&lang=js&"
import style0 from "./VueAudio.vue?vue&type=style&index=0&id=e057a24e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e057a24e",
  null
  
)

export default component.exports